if (typeof ShippingNotice !== 'function') {
	class ShippingNotice extends HTMLElement {
	  constructor() {
		super();
		this.init();
	  }
  
	  init() {
		const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
		const currencyRate = Shopify.currency.rate ? Number(Shopify.currency.rate) : 1;
		const firstGiftThreshold = Math.round(Number(this.getAttribute('data-first-gift-amount')) * currencyRate);
		const shippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * currencyRate);
		const secondGiftThreshold = Math.round(Number(this.getAttribute('data-second-gift-amount')) * currencyRate);
  
		let firstSegmentProgress = 0;
		let secondSegmentProgress = 0;
		let thirdSegmentProgress = 0;
  
		if (cartTotal <= firstGiftThreshold) {
		  firstSegmentProgress = (cartTotal / firstGiftThreshold) * 100;
		} else {
		  firstSegmentProgress = 100;
		  
		  if (cartTotal <= shippingThreshold) {
			secondSegmentProgress = ((cartTotal - firstGiftThreshold) / (shippingThreshold - firstGiftThreshold)) * 100;
		  } else {
			secondSegmentProgress = 100;
			
			if (cartTotal <= secondGiftThreshold) {
			  thirdSegmentProgress = ((cartTotal - shippingThreshold) / (secondGiftThreshold - shippingThreshold)) * 100;
			} else {
			  thirdSegmentProgress = 100;
			}
		  }
		}
  
		// Determine message based on progress
		let message = '';
		if (cartTotal < firstGiftThreshold) {
		  const remaining = firstGiftThreshold - cartTotal;
		  message = window.theme.strings.first_free_gift_remaining_html.replace(
			'{{ remaining_amount }}',
			this._formatMoney(remaining, KROWN.settings.shop_money_format)
		  );
		} else if (cartTotal < shippingThreshold) {
		  const remaining = shippingThreshold - cartTotal;
		  message = `${window.theme.strings.free_gift_eligible}<br>${window.theme.strings.free_shipping_remaining_html.replace(
			'{{ remaining_amount }}',
			this._formatMoney(remaining, KROWN.settings.shop_money_format)
		  )}`;
		} else if (cartTotal < secondGiftThreshold) {
		  const remaining = secondGiftThreshold - cartTotal;
		  message = `${window.theme.strings.free_shipping_eligible}<br>${window.theme.strings.second_free_gift_remaining_html.replace(
			'{{ remaining_amount }}',
			this._formatMoney(remaining, KROWN.settings.shop_money_format)
		  )}`;
		} else {
		  message = window.theme.strings.free_gifts_shipping_eligible;
		}

		const giftIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.48159 7.50003C5.10042 6.96356 4.85116 6.34581 4.74599 5.75687C4.60577 4.97161 4.68791 4.10602 5.14396 3.4095C5.62347 2.67716 6.43931 2.25003 7.49994 2.25003C9.28444 2.25003 10.6188 3.15392 11.4815 4.34015C11.6771 4.6091 11.8499 4.89401 11.9999 5.18881C12.15 4.89401 12.3228 4.6091 12.5184 4.34015C13.3811 3.15392 14.7154 2.25003 16.4999 2.25003C17.5606 2.25003 18.3764 2.67716 18.8559 3.4095C19.312 4.10602 19.3941 4.97161 19.2539 5.75687C19.1487 6.34581 18.8995 6.96356 18.5183 7.50003H19.8749C20.4963 7.50003 20.9999 8.00371 20.9999 8.62503V12.375C20.9999 12.9964 20.4963 13.5 19.8749 13.5H18.7499V19.875C18.7499 20.4963 18.2463 21 17.6249 21H6.37494C5.75362 21 5.24994 20.4963 5.24994 19.875V13.5H4.12494C3.50362 13.5 2.99994 12.9964 2.99994 12.375V8.62503C2.99994 8.00371 3.50362 7.50003 4.12494 7.50003H5.48159ZM13.7315 5.22241C13.2416 5.89597 12.9329 6.71773 12.8103 7.50003H15.7499C16.7567 7.50003 17.5808 6.59321 17.7772 5.49319C17.8714 4.96595 17.7895 4.51904 17.601 4.23118C17.436 3.97915 17.1268 3.75003 16.4999 3.75003C15.2844 3.75003 14.3688 4.34614 13.7315 5.22241ZM11.1896 7.50003C11.067 6.71773 10.7582 5.89597 10.2684 5.22241C9.6311 4.34614 8.71544 3.75003 7.49994 3.75003C6.87307 3.75003 6.56391 3.97915 6.39889 4.23118C6.21041 4.51904 6.12849 4.96595 6.22263 5.49319C6.41907 6.59321 7.24314 7.50003 8.24994 7.50003H11.1896ZM11.2499 9.00003H4.49994V12H11.2499V9.00003ZM12.7499 9.00003H19.4999V12H12.7499V9.00003ZM6.74994 13.5V19.5H11.2499V13.5H6.74994ZM12.7499 13.5V19.5H17.2499V13.5H12.7499Z" fill="currentColor"/>
		</svg>`;

		const truckIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M3.0206 18H1.875C1.25368 18 0.75 17.4963 0.75 16.875V12.2779C0.75 11.8741 0.966322 11.5014 1.31684 11.3011L3.13734 10.2608C3.2935 10.1716 3.42599 10.0462 3.5237 9.89519L7.16751 4.26384C7.37483 3.94345 7.73042 3.75 8.11203 3.75H22.125C22.7463 3.75 23.25 4.25368 23.25 4.875V16.875C23.25 17.4963 22.7463 18 22.125 18H20.9794C20.7929 19.6875 19.3622 21 17.625 21C15.8878 21 14.4571 19.6875 14.2706 18H9.7294C9.54286 19.6875 8.11221 21 6.375 21C4.63779 21 3.20714 19.6875 3.0206 18ZM21.75 5.25V16.5H20.808C20.3446 15.1892 19.0945 14.25 17.625 14.25C16.1555 14.25 14.9054 15.1892 14.442 16.5H9.55795C9.09464 15.1892 7.84449 14.25 6.375 14.25C4.90551 14.25 3.65536 15.1892 3.19205 16.5H2.25V12.4955L3.88155 11.5632C4.03812 11.4737 4.18449 11.3687 4.3186 11.25H12V5.25H21.75ZM10.5 9.75V5.25H8.31604L5.40427 9.75H10.5ZM17.625 19.5C18.6605 19.5 19.5 18.6605 19.5 17.625C19.5 16.5895 18.6605 15.75 17.625 15.75C16.5895 15.75 15.75 16.5895 15.75 17.625C15.75 18.6605 16.5895 19.5 17.625 19.5ZM8.25 17.625C8.25 18.6605 7.41053 19.5 6.375 19.5C5.33947 19.5 4.5 18.6605 4.5 17.625C4.5 16.5895 5.33947 15.75 6.375 15.75C7.41053 15.75 8.25 16.5895 8.25 17.625Z" fill="currentColor"/>
		</svg>`;
	  
	  this.innerHTML = `
		<div class="shipping-notice">
		  <div class="shipping-notice__text">${message}</div>
		  <div class="shipping-progress">
			<div class="progress-segment">
			  <div class="progress-bar" style="width: ${firstSegmentProgress}%"></div>
			</div>
			<div class="icon-wrapper ${firstSegmentProgress === 100 ? 'active' : ''}">
			  ${giftIcon}
			  <span class="label">Dárek zdarma</span>
			</div>
			<div class="progress-segment">
			  <div class="progress-bar" style="width: ${secondSegmentProgress}%"></div>
			</div>
			<div class="icon-wrapper ${secondSegmentProgress === 100 ? 'active' : ''}">
			  ${truckIcon}
			  <span class="label">Doprava zdarma</span>
			</div>
			<div class="progress-segment">
			  <div class="progress-bar" style="width: ${thirdSegmentProgress}%"></div>
			</div>
			<div class="icon-wrapper ${thirdSegmentProgress === 100 ? 'active' : ''}">
			  ${giftIcon}
			  <span class="label">Dárek zdarma</span>
			</div>
		  </div>
		</div>`;
	  }
  
	  _formatMoney(cents, format) {
		if (typeof cents === 'string') {
		  cents = cents.replace('.', '');
		}
		
		let value = '';
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format || moneyFormat;
		
		function formatWithDelimiters(number, precision, thousands, decimal) {
		  thousands = thousands || ',';
		  decimal = decimal || '.';
		  
		  if (isNaN(number) || number === null) {
			return 0;
		  }
		  
		  number = (number / 100.0).toFixed(precision);
		  
		  const parts = number.split('.');
		  const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d\d\d)+(?!\d))/g,
			'$1' + thousands
		  );
		  const centsAmount = parts[1] ? decimal + parts[1] : '';
		  
		  return dollarsAmount + centsAmount;
		}
		
		switch (formatString.match(placeholderRegex)[1]) {
		  case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		  case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		  case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		  case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
		  case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ');
			break;
		  case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'");
			break;
		}
		
		return formatString.replace(placeholderRegex, value);
	  }
	}
  
	if (typeof customElements.get('shipping-notice') == 'undefined') {
	  customElements.define('shipping-notice', ShippingNotice);
	}
  }